import _createClass from "@babel/runtime/helpers/createClass";
import { simulatorRenderSymbol } from '../symbols';
export var SimulatorRender = /*#__PURE__*/function () {
  function SimulatorRender(simulatorRender) {
    this[simulatorRenderSymbol] = void 0;
    this[simulatorRenderSymbol] = simulatorRender;
  }
  SimulatorRender.create = function create(simulatorRender) {
    return new SimulatorRender(simulatorRender);
  };
  var _proto = SimulatorRender.prototype;
  _proto.rerender = function rerender() {
    return this[simulatorRenderSymbol].rerender();
  };
  _createClass(SimulatorRender, [{
    key: "components",
    get: function get() {
      return this[simulatorRenderSymbol].components;
    }
  }]);
  return SimulatorRender;
}();